import type { FilterGroupType } from '~/components/Filters/types.flow';

const deserializeFilters = (filters: string): FilterGroupType =>
  JSON.parse(atob(decodeURIComponent(filters)));

export default deserializeFilters;
